import React, { useEffect, useState } from "react";
import { Card, Form, Row, Col, InputGroup, Button } from "react-bootstrap";
import { FaSearch, FaFilter } from "react-icons/fa";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import "./filterCard.css";
import { useAuth } from "../../Utils/Auth";

const FilterCard = ({
  visibleFilters = {
    transactionType: true,
    subAdmin: true,
    introducer: true,
    bankName: true,
    websites: true,
    amountRange: true,
    transactionId: true,
    dateRange: true,
  },
  options = {
    transactionTypes: [],
    subAdmins: [],
    introducers: [],
    bankNames: [],
    websites: [],
  },
  onFilterReset,
  state,
  setState,
  setDebouncedSearch,
  handleDownloadExcel,
  isExcelDownloadable,
  setItemPerPage,
  fetchCharges,
  totalCharge,
  totalTransactionAmount

}) => {
  console.log(totalTransactionAmount, "line 39")
  const [dropDownVisible, setDropDownVisible] = useState({
    admin: false,
    bank: false,
    website: false,
    introducer: false,
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setState((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (
      name === "adminSerachQuery" ||
      name === "introducerSerachQuery" ||
      name === "bankSerachQuery" ||
      name === "websiteSerachQuery"
    ) {
      setState((prev) => ({
        ...prev,
        [name]: value,
        serachQuery: value,
      }));
    }
  };
  const auth = useAuth();
  const handleDateChange = (date, field) => {
    setState((filterValues) => ({
      ...filterValues,
      [field]: date,
    }));
  };

  const handleReset = () => {
    onFilterReset();
    fetchCharges(1); // reset ke baad bhi api hit

  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearch(state.serachQuery);
    }, 300);

    return () => {
      clearTimeout(timerId);
    };
  }, [state.serachQuery]);

  const handleWebsiteDropDown = (isShow) => {
    setDropDownVisible((state) => ({
      ...state,
      website: isShow,
    }));
  };

  const handleBankDropDown = (isShow) => {
    setDropDownVisible((state) => ({
      ...state,
      bank: isShow,
    }));
  };

  const handleAdminDropDown = (isShow) => {
    setDropDownVisible((state) => ({
      ...state,
      admin: isShow,
    }));
  };

  const handleIntroducerDropDown = (isShow) => {
    setDropDownVisible((state) => ({
      ...state,
      introducer: isShow,
    }));
  };

  return (
    <Card className="filter-card m-2">
      <Card.Header className="d-flex align-items-center text-black">
        <FaFilter className="me-2" />
        <h5 className="mb-0">Filter Options</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          {/* Date Range */}
          {visibleFilters.dateRange && (
            <Col md={6} lg={4} xl={3} className="mb-3">
              <Form.Group>
                <Form.Label>Date Range</Form.Label>
                <div className="d-flex">
                  <Datetime
                    value={state.startDate}
                    onChange={(date) => handleDateChange(date, "startDate")}
                    dateFormat="DD-MM-YYYY"
                    timeFormat="HH:mm"
                    placeholderText="Start Date"
                  />
                  <h6 className="fw-bold text-nowrap m-2">To</h6>

                  <Datetime
                    value={state.endDate}
                    onChange={(date) => handleDateChange(date, "endDate")}
                    dateFormat="DD-MM-YYYY"
                    timeFormat="HH:mm"
                  />
                </div>
              </Form.Group>
            </Col>
          )}

          {visibleFilters.transactionType && (
            <Col xs={12} sm={6} md={6} lg={4} xl={3} className="mb-3">
              <Form.Group controlId="transactionType">
                <Form.Label>Transaction Type</Form.Label>
                <Form.Select
                  name="transactionType"
                  className="w-100"
                  value={state.transactionType}
                  onChange={handleInputChange}
                >
                  <option value="">All Types</option>
                  {options?.transactionTypes?.map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </Form.Select>

              </Form.Group>
            </Col>
          )}

          {/* <Col xs={12} sm={6} md={6} lg={4} xl={3} className="mb-3">
            <Form.Group controlId="transactionType">
              <Form.Label className="mt-2">Total Charge :</Form.Label>
              <h5 className="text-success">{totalCharge}.00</h5>
            </Form.Group>
          </Col> */}

          {/* SubAdmin Search */}
          {visibleFilters.subAdmin && (
            <Col md={6} lg={4} xl={3} className="mb-3">
              <Form.Group>
                <Form.Label>Admin</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="adminSerachQuery"
                    value={state.admin || state.adminSerachQuery}
                    onChange={handleInputChange}
                    placeholder="Search Admin"
                    onFocus={() => handleAdminDropDown(true)}
                    onBlur={() => handleAdminDropDown(false)}
                  />
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>

              {dropDownVisible.admin && (
                <ul
                  className="dropdown-list  w-100"
                  type="none"
                >
                  {state.searchedAdmin.length > 0 ? (
                    state.searchedAdmin.map((option, index) => (
                      <li
                        key={index}
                        onMouseDown={() => {
                          setState((state) => ({
                            ...state,
                            admin: option.userName,
                            adminSerachQuery: "",
                          }));
                          handleIntroducerDropDown(false);
                        }}
                        className="dropdown-item"
                      >
                        {option.userName}
                      </li>
                    ))
                  ) : state.adminSerachQuery !== "" ? (
                    <li className="dropdown-item">No Results</li>
                  ) : (
                    <li className="dropdown-item">Please Search</li>
                  )}
                </ul>
              )}
            </Col>
          )}

          {/* Introducer Search */}
          {visibleFilters.introducer && (
            <Col md={6} lg={4} xl={3} className="mb-3">
              <Form.Group>
                <Form.Label>Introducer</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="introducerSerachQuery"
                    value={state.introducer || state.introducerSerachQuery}
                    onChange={handleInputChange}
                    placeholder="Search Introducer"
                    onFocus={() => handleIntroducerDropDown(true)}
                    onBlur={() => handleIntroducerDropDown(false)}
                  />
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
              {dropDownVisible.introducer && (
                <ul className="dropdown-list show w-100" type='none'>
                  {state.searchedIntroducer.length > 0 ? (
                    state.searchedIntroducer.map((option, index) => (
                      <li
                        key={index}
                        onMouseDown={() => {
                          setState((state) => ({
                            ...state,
                            introducer: option.userName,
                            introducerSerachQuery: "",
                          }));
                          handleIntroducerDropDown(false);
                        }}
                        className="dropdown-item"
                      >
                        {option.userName}
                      </li>
                    ))
                  ) : state.introducerSerachQuery !== "" ? (
                    <li style={{ padding: "8px" }} className="dropdown-item">
                      No Results
                    </li>
                  ) : (
                    <li style={{ padding: "8px" }} className="dropdown-item">
                      Please Search
                    </li>
                  )}
                </ul>
              )}
            </Col>
          )}

          {/* Transaction ID  */}
          {visibleFilters.transactionId && (
            <Col md={6} lg={4} xl={3} className="mb-3">
              <Form.Group>
                <Form.Label>Transaction ID</Form.Label>
                <Form.Control
                  type="text"
                  name="transactionId"
                  value={state.transactionId}
                  onChange={handleInputChange}
                  placeholder="Enter Transaction ID"
                />
              </Form.Group>
            </Col>
          )}

          {/* Bank Name Search */}
          {visibleFilters.bankName && (
            <Col md={6} lg={4} xl={3} className="mb-3">
              <Form.Group>
                <Form.Label>Bank Name</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="bankSerachQuery"
                    value={state.bank || state.bankSerachQuery}
                    onChange={handleInputChange}
                    placeholder="Search Bank"
                    onFocus={() => handleBankDropDown(true)}
                    onBlur={() => handleBankDropDown(false)}
                  />
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>

              {dropDownVisible.bank && (
                <ul
                  className="dropdown-list show w-100"
                  type='none'
                >
                  {state.searchedBank.length > 0 ? (
                    state.searchedBank.map((option, index) => (
                      <li
                        key={index}
                        onMouseDown={() => {
                          setState((state) => ({
                            ...state,
                            bank: option.bankName,
                            bankSerachQuery: "",
                          }));
                          handleWebsiteDropDown(false);
                        }}
                        className="dropdown-item"
                      >
                        {option.bankName}
                      </li>
                    ))
                  ) : state.bankSerachQuery !== "" ? (
                    <li style={{ padding: "8px" }} className="dropdown-item">
                      No Results
                    </li>
                  ) : (
                    <li style={{ padding: "8px" }} className="dropdown-item">
                      Please Search
                    </li>
                  )}
                </ul>
              )}
            </Col>
          )}

          {/* Websites Search */}
          {visibleFilters.websites && (
            <Col md={6} lg={4} xl={3} className="mb-3">
              <Form.Group>
                <Form.Label>Website</Form.Label>
                <InputGroup>
                  <Form.Control
                    type="text"
                    name="websiteSerachQuery"
                    value={state.website || state.websiteSerachQuery}
                    onChange={handleInputChange}
                    placeholder="Search Website"
                    onFocus={() => handleWebsiteDropDown(true)}
                    onBlur={() => handleWebsiteDropDown(false)}
                  />
                  <InputGroup.Text>
                    <FaSearch />
                  </InputGroup.Text>
                </InputGroup>
              </Form.Group>
              {dropDownVisible.website && (
                <ul
                  className="dropdown-list show w-100"
                  type='none'
                >
                  {state.searchedWebsite.length > 0 ? (
                    state.searchedWebsite.map((option, index) => (
                      <li
                        key={index}
                        onMouseDown={() => {
                          setState((state) => ({
                            ...state,
                            website: option.websiteName,
                            websiteSerachQuery: "",
                          }));
                          handleWebsiteDropDown(false);
                        }}
                        className="dropdown-item"
                      >
                        {option.websiteName}
                      </li>
                    ))
                  ) : state.websiteSerachQuery !== "" ? (
                    <li style={{ padding: "8px" }} className="dropdown-item">
                      No Results
                    </li>
                  ) : (
                    <li style={{ padding: "8px" }} className="dropdown-item">
                      Please Search
                    </li>
                  )}
                </ul>
              )}
            </Col>
          )}

          {/* Amount Range */}
          {visibleFilters.amountRange && (
            <Col md={6} lg={4} xl={3} className="mb-3">
              <Form.Group>
                <Form.Label>Amount Range</Form.Label>
                <div className="d-flex">
                  <Form.Control
                    type="number"
                    name="minAmount"
                    value={state.minAmount}
                    onChange={handleInputChange}
                    placeholder="Min Amount"
                    className="me-2"
                  />
                  <Form.Control
                    type="number"
                    name="maxAmount"
                    value={state.maxAmount}
                    onChange={handleInputChange}
                    placeholder="Max Amount"
                  />
                </div>
              </Form.Group>
            </Col>
          )}
        </Row>


        <div class="d-flex flex-row-reverse">
          <div class="p-2">
            <Button
              variant="primary"
              onClick={handleDownloadExcel}
              style={{ backgroundColor: "#4682b4", border: '1px solid #424242' }}
              size="sm"
              disabled={!isExcelDownloadable}
            >
              Download Excel
            </Button>
          </div>
          <div class="p-2">
            <Button
              variant="outline-secondary"
              onClick={handleReset}
              // className="me-2"
              size="sm"
            >
              Reset Filters
            </Button>
          </div>
          {/* <div class="p-2">
            <Form.Select size="sm" onChange={(e)=>setItemPerPage(e.target.value)} disabled={!isExcelDownloadable}>
              <option value={10}>10</option>
              <option value={25}>25</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
            </Form.Select>
          </div> */}
          {/* <Form.Label style={{marginTop:'13px'}}>
            Page Size :
          </Form.Label> */}
        </div>

        {/* <div className="d-flex justify-content-end mt-1">
          <Button
            variant="outline-secondary"
            onClick={handleReset}
            className="me-2"
          >
            Reset
          </Button>
          <Button
            variant="primary"
            // onClick={handleApply}
            style={{ backgroundColor: "#4682b4" }}
          >
            Apply Filters
          </Button>
        </div> */}

        <div className="d-flex justify-content-start text-bold  mt-1">  
       
          <div className="me-2">
           <span className="text-red"> Total Charge Amount</span>: <span className="text-green">{totalTransactionAmount || totalCharge}</span>
          </div>

        </div>
      </Card.Body>
    </Card>
  );
};

export default FilterCard;
